// extracted by mini-css-extract-plugin
export default {"scroll-container":"slide-out-action_scroll-container__tsCs5","scrollContainer":"slide-out-action_scroll-container__tsCs5"};